import React from 'react'

const Unauthorized = () => {
  return <h1 className='text-danger'>Unauthorized</h1>
}

export default Unauthorized
